<template>
    <flex-element :element-type="elementType" tag="li">
        <a-link
            class-default="f-w-1/1"
            v-bind="element(1)"
            is-dynamic-element
            @delete-element="onDelete"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Collection Item',
        },

        index: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            cssDisplay: 'block',
        };
    },

    methods: {
        onDelete() {
            this.$emit('delete-element', this.index);
        },
    },
};
</script>
